/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

// selector helpers
import { RootState } from '../reducers';
import { LinkedUniversalTracker } from '../types/initiative';
import { UniversalTrackerMin, UniversalTrackerPlain } from '../types/universalTracker';
import { KeyUtrvs } from '../types/universalTrackerValue';
import { createSelector } from '@reduxjs/toolkit';
import { SUMMARY_DASHBOARD_UTR_TABLE } from '../constants/usage-slots';

export type UtrAttribute = KeyUtrvs | null
export type UtrLookup = UniversalTrackerMin;

const getUniversalTrackerValues = (state: RootState, universalTracker: UtrLookup, type?: string) => {

  if (!state.initiative.data?._id || !state.universalTrackerValues.data
    || state.universalTrackerValues.data.length === 0) {
    return;
  }

  return state.universalTrackerValues.data
    .filter((utrv) => utrv.universalTrackerId === universalTracker._id && (type ? utrv.type === type : true))
    .sort((a, b) => {
      return (a.effectiveDate > b.effectiveDate) ? 1 : (a.effectiveDate < b.effectiveDate) ? -1 : 0;
    });
};

export const getUniversalTrackerValueLatestAttribute = (state: RootState, universalTracker: UtrLookup, type: string, attribute: UtrAttribute = null) => {
  let universalTrackerValues = getUniversalTrackerValues(state, universalTracker, type);
  if (!universalTrackerValues || !Array.isArray(universalTrackerValues) || universalTrackerValues.length === 0) {
    return;
  }

  const universalTrackerValue = universalTrackerValues[0];
  if (!universalTrackerValue) {
    return;
  }

  return attribute ? universalTrackerValue[attribute] : universalTrackerValue;
};

const processUtrs = (
  usages: string[],
  linkedUniversalTrackers: LinkedUniversalTracker[],
  utrsData: UniversalTrackerPlain[],
) => {
  const filteredLinkedUniversalTrackers = usages.map(usage => {
    return linkedUniversalTrackers.filter(universalTracker => universalTracker.usage && universalTracker.usage.includes(usage));
  }).flat();

  const universalTrackers: UniversalTrackerPlain[] = [];

  // Now merge the usages array from initiatives, to the universalTracker states
  filteredLinkedUniversalTrackers.forEach((filteredLinkedUniversalTracker) => {
    const findUniversalTracker = utrsData.find(
      (universalTracker: { _id: string }) => filteredLinkedUniversalTracker.universalTrackerId === universalTracker._id
    );
    if (!findUniversalTracker) {
      return;
    }
    universalTrackers.push(
      { ...filteredLinkedUniversalTracker, ...findUniversalTracker }
    );
  });

  return universalTrackers;
};

export const getSummaryUtrTable = createSelector([
  (state) => state.initiative.data?.linkedUniversalTrackers,
  (state) => state.universalTrackers.data,
], (linkedUniversalTrackers, utrsData) => {
  return processUtrs([SUMMARY_DASHBOARD_UTR_TABLE], linkedUniversalTrackers, utrsData);
})
